import { forEach } from "jszip";

function getFileData(fileData, parentId) {
    let result = [];
    fileData.forEach((i,index) => {
      if (i.parentId == parentId) {
        result.push(i);
      }
    }) 
    return result;
}

function getDirData(fileData, id) {

    var result = fileData.filter(function (s) {
        return s.id == id; 
    });
    return result[0];
}

function getAllDirs(fileData, id) {
    let result = [];
    let dir = getDirData(fileData, id);
    result.push(dir);
    let parentId = dir.parentId;
    while (parentId != 0) {
      dir = getDirData(fileData, parentId);
      parentId = dir.parentId;
      result.push(dir)
    }
    return result.reverse();
}

//包含parentId的记录,生成带children结构
function generateTree(records, parentId, level) {
  const tree = [];
  for (let record of records) {
    if (record.parentId === parentId) {
      const children = generateTree(records, record.id, level + 1);      
      if (children.length > 0) {
        record.children = children;
      }
      record.level = level;    
      tree.push(record);
    }
  }  
  return tree;
}


export  {
    getFileData,getDirData,getAllDirs,generateTree
}



// WEBPACK FOOTER //
// ./src/utils/sysData.js